import type { ReactNode } from 'react';
import { Link } from 'react-router';
import ChevronLeftIcon from '@/assets/icons/chevron-left.svg?react';
import { ROUTES } from '@/shared/config/routes';
import { Wordmark } from '@/shared/ui/wordmark';

/** Plans and checkout: no sidebar, one way back. */
export function CheckoutLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-bg text-body-lg text-ink">
      <header className="flex flex-wrap items-center justify-between gap-4 px-4 py-4.5 shell:px-10">
        <Link to={ROUTES.OVERVIEW}>
          <Wordmark />
        </Link>
        <Link
          to={ROUTES.BILLING}
          className="inline-flex items-center gap-1.5 text-muted hover:text-ink"
        >
          <ChevronLeftIcon className="size-4" />
          Back to billing
        </Link>
      </header>
      <main className="mx-auto flex w-full max-w-295 flex-1 flex-wrap items-start gap-10 px-4 pt-6 pb-16 shell:px-10">
        {children}
      </main>
    </div>
  );
}
